import Header from "./Header";
import Footer from "./Footer";
import ConciergeWidget from "../ai-chat/ConciergeWidget";
import CookieBanner from "./CookieBanner";
import ScrollProgress from "../global/ScrollProgress";
import SpotlightCursor from "../global/SpotlightCursor";
import CommandPalette from "../global/CommandPalette";
import EasterEgg from "../global/EasterEgg";
import BackToTop from "../global/BackToTop";
import AnimatedBackground from "../shared/AnimatedBackground";
import BackgroundGrid from "../shared/BackgroundGrid";

export const Layout = ({ children }) => {
  return (
    <div className="relative z-0 min-h-screen bg-app spotlight-cursor-scope">
      <BackgroundGrid />
      <AnimatedBackground />
      <ScrollProgress />
      <SpotlightCursor />
      <CommandPalette />
      <EasterEgg />
      <Header />
      <main className="pt-24">{children}</main>
      <Footer />
      <ConciergeWidget />
      <BackToTop />
      <CookieBanner />
    </div>
  );
};

export default Layout;
